import { cn } from "@/lib/utils";
import type { ContractStatus } from "@/hooks/use-extra-contracts";

/**
 * VIB-1281: statusbadge for en kontraktinstans i StatisterTab.
 * `status` er undefined når ingen kontrakt er generert ennå.
 */
export default function ContractStatusBadge({ status }: { status: ContractStatus | undefined }) {
  if (!status) {
    return <span className="text-xs text-muted-foreground">Ingen kontrakt</span>;
  }

  const styles: Record<ContractStatus, string> = {
    utkast: "bg-gray-100 text-gray-700",
    sendt: "bg-blue-100 text-blue-700",
    signert: "bg-green-100 text-green-700",
    annullert: "bg-red-100 text-red-700",
  };

  const labels: Record<ContractStatus, string> = {
    utkast: "Utkast",
    sendt: "Sendt",
    signert: "Signert",
    annullert: "Annullert",
  };

  return (
    <span className={cn("text-xs px-1.5 py-0.5 rounded", styles[status])}>
      {labels[status]}
    </span>
  );
}
